const samplingQuotesTableColumns = [
  {
    key: 'type',
    label: 'Type',
    allowsSorting: true
  },
  {
    key: 'price',
    label: 'Production unit cost',
    allowsSorting: true
  },
  {
    key: 'quantity',
    label: 'Quantity',
    allowsSorting: true
  },
  {
    key: 'supplier',
    label: 'Supplier',
    allowsSorting: true
  },
  {
    key: 'created_at',
    label: 'Uploaded date',
    allowsSorting: true
  }
];

export default samplingQuotesTableColumns;
